import React, { useEffect, useState } from 'react';
import { Form } from 'antd';
import { PropertyUseCaseInterface } from 'application/usecases/PropertyUseCase';
import { UserUseCaseInterface } from 'application/usecases/UserUseCase';
import FallbackImg from 'assets/images/FallbackImg.svg';
import { ListedPropertyDetailMemberAuctionProperty } from 'domain/entities/PropertyEntity';
import { ConfirmModalProps } from 'presentation/components/Modal/Modal.type';
import { openErrorNoti, openSuccessNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import {
    completeFetching,
    showConfirm,
    startFetching,
} from 'presentation/redux/features/app/appSlice';
import { ImageComponent } from 'presentation/components/ImageComponent';
import { useAppDispatch, useAppSelector } from 'presentation/redux/hooks';
import { ACCOUNT_RANK, PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate, useParams } from 'react-router-dom';
import { COMMON } from 'utilities/constants/COMMON';
import { commonHelpers } from 'utilities/helpers';
import { ImageRow } from './components/ImageRow';
import { MarketPrice } from './components/MarketPrice';
import { PropertyDescription } from './components/PropertyDescription';

interface props {
    propertyUseCase: PropertyUseCaseInterface;
    userUseCase: UserUseCaseInterface;
}

const CU00901Page = ({ propertyUseCase, userUseCase }: props) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const { listedPropertyId } = useParams();
    const [isBookmarked, setIsBookmarked] = useState<boolean>(false);
    const [countLike, setCountLike] = useState<number>(0);
    const [title, setTitle] = useState<any>();
    const [detailAssessment, setDetailAssessment] =
        useState<ListedPropertyDetailMemberAuctionProperty>();
    const storedInput = useAppSelector((state) => state.CU03101Slice.storedInput);
    const userSlice = useAppSelector((state) => state.user);
    const [dataNavigate, setDataNavigate] = React.useState<any>();
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        (async () => {
            if (storedInput) form.setFieldsValue(storedInput);

            await getListedPropertyRoomGetAssessmentDetail({
                listedPropertyId: Number(listedPropertyId),
                isLogin: userSlice?.isSignedIn ? 1 : 0,
            });
        })();
    }, []);

    useEffect(() => {
        setIsBookmarked(detailAssessment?.currentBookmark ?? false);
        setCountLike(detailAssessment?.liked || 0);
        if (!detailAssessment?.auctionTime) {
            setTitle(<>入札一時停止中</>);
        } else {
            let title = '';
            if (!detailAssessment?.auctionTime) {
                title = COMMON.EMPTY;
            } else {
                if (detailAssessment?.auctionTime.days && detailAssessment?.auctionTime.days > 0) {
                    if(detailAssessment?.auctionTime.h > 0){
                        title = '入札締切まであと' + (Number(detailAssessment?.auctionTime.days)+1) + '日';
                    } else {
                        title = '入札締切まであと' + detailAssessment?.auctionTime.days + '日';
                    }
                } else if (
                    detailAssessment?.auctionTime.days < 1 &&
                    detailAssessment?.auctionTime.h &&
                    detailAssessment?.auctionTime.h > 0
                ) {
                    title = '入札締切まで' + 'あと' + detailAssessment?.auctionTime.h + '時間';
                } else {
                    title = "入札一時停止中";
                }
            }
            setTitle(title);
        }
        if (detailAssessment) {
            setDataNavigate({
                name: detailAssessment.name,
                rateBuyNow: detailAssessment.rateBuyNow,
                rateHighestAuctionNow: detailAssessment.rateHighestAuctionNow,
                currentHighestAuctionPrice: detailAssessment.currentHighestAuctionPrice,
                askingSalePriceUpperLimit: detailAssessment.askingSalePriceUpperLimit,
                yourAuctionBid: detailAssessment.yourAuctionBid,
                rent: detailAssessment.rent,
                rateYourAuctionBids: detailAssessment.rateYourAuctionBids,
                auctionId: detailAssessment.auctionId,
                currentScheduleSeq: detailAssessment.currentScheduleSeq,
                auctionTime: detailAssessment.auctionTime,
                auctionStatus: detailAssessment.auctionStatus,
            });
        }
    }, [detailAssessment]);

    const getListedPropertyRoomGetAssessmentDetail = async (params: {
        listedPropertyId: number;
        isLogin?: number;
    }) => {
        try {
            dispatch(startFetching());
            const response = await propertyUseCase.getDetailAuctionOfMember(params);
            if (response) {
                setDetailAssessment(response.result);
                setCountLike(response.result.liked);
                setIsBookmarked(response.result?.currentBookmark ?? false);
                if (response.result.memberIsNotWinning) {
                    openSuccessNoti({ title: '', description: 'あなたの入札額を上回る入札がありました。' });
                }
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const onclickBookmark = async () => {
        try {
            dispatch(startFetching());
            if (propertyUseCase) {
                const response = await propertyUseCase.memberBookMarkListedProperty({
                    listedPropertyId: Number(listedPropertyId),
                });
                if (response.status == '200') {
                    const likeCount = await propertyUseCase.countLike(Number(listedPropertyId));
                    if (likeCount.status == '200') {
                        setIsBookmarked(!isBookmarked);
                        setCountLike(likeCount.result);
                    }
                }
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const goToBid = async () => {
        dispatch(startFetching());
        try {
            //getUserInfo
            const response = await userUseCase.getUserInfo();
            const memberInfo = response.result;
            if (memberInfo.accountRank == ACCOUNT_RANK.NORMAL) {
                const confirmProps: ConfirmModalProps = commonHelpers.getConfirmProps('CU-009-01', {
                    onOk: registUserInformation,
                });
                dispatch(showConfirm(confirmProps));
            } else {
                navigate(
                    `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_013_01}/${listedPropertyId}`,
                    { state: { ...dataNavigate } },
                );
            }
        } catch (error) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const registUserInformation = async () => {
        dispatch(startFetching());
        try {
            if (!isBookmarked) {
                await propertyUseCase.memberBookMarkListedProperty({
                    listedPropertyId: Number(listedPropertyId),
                });
            }
        } catch (error) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
            navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_004_00}`);
        }
    };

    const nextImage = () => {
        if (detailAssessment && detailAssessment.images) {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % detailAssessment.images.length);
        }
    };

    const prevImage = () => {
        if (detailAssessment && detailAssessment.images) {
            setCurrentIndex((prevIndex) => (prevIndex - 1 + detailAssessment.images.length) % detailAssessment.images.length);
        }
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
                paddingLeft: 20,
            }}
            className="CU-009-01-container"
        >
            <PageTitle title={title} />
            <section
                style={{
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                {(detailAssessment && (
                    <div className="main-container">
                        {detailAssessment.images.length === 0 ? (
                            <ImageRow imageURLs={[FallbackImg]} />
                        ) : (
                            <div style={{ position: 'relative', width: '100%', overflow: 'hidden' }}>
                                <button
                                    style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '10px',
                                        justifyContent: 'center',
                                        transform: 'translateY(-50%)',
                                        zIndex: 1,
                                    }}
                                    onClick={prevImage}
                                >
                                    {'<'}
                                </button>
                                <div
                                    style={{
                                        display: 'flex',
                                        transition: 'transform 0.5s ease-in-out',
                                        transform: `translateX(-${currentIndex * 100}%)`,
                                        width: `100%`,
                                    }}
                                >
                                    {detailAssessment.images.map((image: any, index: number) => (
                                        <div
                                            key={index}
                                            style={{
                                                minWidth: '100%',
                                                boxSizing: 'border-box',
                                            }}
                                        >
                                            <ImageComponent
                                                parentClassName="h-164 full-width"
                                                className="image-inside min-h-[335px]"
                                                src={image.fileUrl.length > 0 ? image.fileUrl : FallbackImg}
                                                style={{ justifyContent: "center", objectFit: "contain", height: "300px"}}
                                            />
                                        </div>
                                    ))}
                                </div>
                                <button
                                    style={{
                                        position: 'absolute',
                                        top: '50%',
                                        right: '10px',
                                        transform: 'translateY(-50%)',
                                    }}
                                    onClick={nextImage}
                                >
                                    {'>'}
                                </button>
                            </div>
                        )}

                        <MarketPrice
                            detailAssessment={detailAssessment}
                            isBookmarked={isBookmarked}
                            countLike={countLike}
                            onClickBookmark={onclickBookmark}
                        />
                        <PropertyDescription
                            detailAssessment={detailAssessment}
                            goToBid={goToBid}
                        />
                    </div>
                )) ||
                    null}
            </section>
        </div>
    );
};

export default CU00901Page;
